import { useEffect, useState } from "react";

/**
 * Returns a debounced copy of value that only updates after `delayMs` of
 * stillness. Use to gate a value behind an input so that downstream effects
 * (queries, network calls) only fire when the user pauses.
 */
export function useDebounce<T>(value: T, delayMs = 250): T {
	const [debounced, setDebounced] = useState(value);

	useEffect(() => {
		const handle = window.setTimeout(() => setDebounced(value), delayMs);
		return () => window.clearTimeout(handle);
	}, [value, delayMs]);

	return debounced;
}
